import { crudTable, date, index, text } from "@-/dev.improve.haniverse.lib.database.table";

// Recently searched morphemes for the current user (actor DB). One row per grapheme `front`:
// the row id is derived from it (`deriveMorphemeSearchVisitId`), and `searched_at` is updated when
// the user searches the same morpheme again. No unique index guards `front`, and none may be added
// (sync cannot resolve a unique conflict).
export const morphemeSearchVisitTable = crudTable(
  "morpheme_search_visit",
  {
    front: text("front").notNull(),
    searchedAt: date("searched_at").notNull(),
  },
  (table) => [index("morpheme_search_visit_front_idx").on(table.front)],
);

export type MorphemeSearchVisit = typeof morphemeSearchVisitTable.$inferSelect;
